<!--Diseño viejito en pasos-->
<div *ngIf="false">
    <div class="header-container">
        <span class="fs-20px font-weight-bold text-white">{{headerTitle}} - {{proveedorForm.value.nombre}}</span>
        <span class="text-white fs-16px" style="cursor: pointer;" (click)="closeDialog()">
            <i class="fa-solid fa-square-xmark"></i>
        </span>
    </div>
    <div *ngIf="!loadingView" class="dialog-container">
        <form [formGroup]="proveedorForm">
            <div class="col-12 mb-2">
                <div class="nav-wizards-container">
                    <nav class="nav nav-wizards-1 mb-2">
                        <div class="nav-item col">
                            <a class="nav-link "
                                [ngClass]="{'active': step === 1, 'completed': step > 1, 'disabled': step < 1}">
                                <div class="nav-no">1</div>
                                <div class="nav-text">Datos de Proveedor</div>
                            </a>
                        </div>
                        <div class="nav-item col">
                            <a class="nav-link "
                                [ngClass]="{'active': step === 2, 'completed': step > 2, 'disabled': step < 2}">
                                <div class="nav-no">2</div>
                                <div class="nav-text">Datos de Contacto</div>
                            </a>
                        </div>
                        <div class="nav-item col">
                            <a class="nav-link "
                                [ngClass]="{'active': step === 3, 'completed': step > 3, 'disabled': step < 3}">
                                <div class="nav-no">3</div>
                                <div class="nav-text">Datos Fiscales</div>
                            </a>
                        </div>
                        <div class="nav-item col">
                            <a class="nav-link "
                                [ngClass]="{'active': step === 4, 'completed': step > 4, 'disabled': step < 4}">
                                <div class="nav-no">4</div>
                                <div class="nav-text">Documentación</div>
                            </a>
                        </div>
                    </nav>
                </div>
            </div>
            <div class="col-12">

                <fieldset *ngIf="step === 1" class="mb-4 fieldset-container">
                    <legend class="custom-legend">Datos de Proveedor</legend>

                    <div class="row">

                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Tipo de Persona</span>
                            <select class="form-select form-select-lg"
                                [ngClass]="{'invalid-form': mostrarError.tipoPersona }" formControlName="tipoPersona">
                                <option value="">Selecciona una Opción</option>
                                <option *ngFor="let item of tipoPersona" [value]="item.tipoPersonaId">
                                    {{item.clavePersona}} - {{item.descripcionPersona}}</option>
                            </select>
                            <p *ngIf="mostrarError.tipoPersona" class="invalid-form-p">Por favor, selecciona una opción
                                válida.</p>
                        </div>
                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">ID CIF</span>
                            <input class="form-control" [ngClass]="{'invalid-form': mostrarError.idRfc }"
                                formControlName="idRfc" (input)="validarNumeros('idRfc')" type="text" maxlength="11"
                                placeholder="Ingresa el ID CIF" (blur)="habilitarRFC()" />
                            <p *ngIf="mostrarError.idCif" class="invalid-form-p">{{erroridCIFMessage}}</p>
                            <!-- <p *ngIf="mostrarError.idRfc" class="invalid-form-p">Por favor, ingresa una ID CIF</p> -->
                        </div>
                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">RFC</span>
                            <input class="form-control" [ngClass]="{'invalid-form': mostrarError.rfc }"
                                formControlName="rfc" type="text" placeholder="Ingresa RFC de Proveedor" />
                            <p *ngIf="mostrarError.rfc" class="invalid-form-p">Por favor, ingresa el RFC</p>
                        </div>

                        <!-- <div class="col-6">
                        <span class="fs-14px font-weight-bold">Estatus</span>
                        <select class="form-select form-select-lg" formControlName="estatus">
                            <option value="">Selecciona una Opción</option>
                            <option *ngFor="let item of estatus" [value]="item.estatusProveedorId">{{item.descripcion}}</option>
                        </select>
                        <p *ngIf="mostrarError.moneda" class="invalid-form-p">Por favor, selecciona una opción válida</p>
                    </div> -->
                    </div>
                    <div class="row mb-2">

                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Nombre Proveedor</span>
                            <input class="form-control" [ngClass]="{'invalid-form': mostrarError.nombre }"
                                formControlName="nombre" type="text" placeholder="Ingresa Nombre de Proveedor" />
                            <p *ngIf="mostrarError.nombre" class="invalid-form-p">Por favor, ingresa un nombre.</p>
                        </div>

                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Razón Social</span>
                            <input class="form-control" [ngClass]="{'invalid-form': mostrarError.razonSocial }"
                                formControlName="razonSocial" type="text"
                                placeholder="Ingresa Razón Social de Proveedor" />
                            <p *ngIf="mostrarError.razonSocial" class="invalid-form-p">Por favor, ingresa una razón
                                social</p>
                        </div>
                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Moneda</span>
                            <mat-select class="form-control" style="font-size: 14px;"
                                placeholder="Selecciona uno o más tipos de moneda" multiple [(value)]="monedaSelect">
                                <mat-option *ngFor="let option of tipoMoneda" [value]="option.tipoMonedaId"
                                    [disabled]="false">{{option.clave}} - {{option.descripcion}}</mat-option>
                            </mat-select>
                            <p *ngIf="mostrarError.moneda" class="invalid-form-p">Por favor, selecciona una opción
                                válida</p>
                        </div>
                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Empresa</span>
                            <mat-select class="form-control" style="font-size: 14px;"
                                placeholder="Selecciona uno o más empresas" multiple [(value)]="empresaSelect"
                                (selectionChange)="validarSeleccion()">
                                <mat-option *ngFor="let option of empresas" [value]="option.empresaId"
                                    [disabled]="false">{{option.nombreEmpresa}}</mat-option>
                            </mat-select>
                            <p *ngIf="mostrarError.empresa" class="invalid-form-p">Por favor, selecciona una opción
                                válida</p>
                        </div>

                    </div>
                </fieldset>

                <fieldset *ngIf="step === 2" class="mb-4 fieldset-container">
                    <legend class="custom-legend">Datos de Contacto</legend>
                    <div class="row mb-2">

                        <div class="col-6">
                            <span class="fs-14px font-weight-bold">Correo Electrónico</span>
                            <input class="form-control" [ngClass]="{'invalid-form': mostrarError.correo }"
                                formControlName="correo"
                                [ngClass]="{'invalid-form': !validEmail,  'valid-form': validEmail }"
                                (ngModelChange)="validarEmail($event)" type="text"
                                placeholder="Ingresa Correo Electrónico de Proveedor" />
                            <p *ngIf="mostrarError.correo || errorValidarCorreo" class="invalid-form-p">Por favor,
                                ingresa un correo válido.</p>
                        </div>

                        <div class="col-6">
                            <span class="fs-14px font-weight-bold">Dirección</span>
                            <input class="form-control" [ngClass]="{'invalid-form': mostrarError.direccion }"
                                formControlName="direccion" type="text" placeholder="Ingresa Dirección de Proveedor" />
                            <p *ngIf="mostrarError.direccion" class="invalid-form-p">Por favor, ingresa una direción.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <span class="fs-14px font-weight-bold">Teléfono</span>
                            <input class="form-control" [ngClass]="{'invalid-form': mostrarError.telefono }"
                                formControlName="telefono" type="text" placeholder="Ingresa Teléfono de Proveedor" />
                            <p *ngIf="mostrarError.telefono" class="invalid-form-p">Por favor, ingresa un teléfono.</p>
                        </div>
                        <div class="col-6">
                            <span class="fs-14px font-weight-bold">Contacto de Facturación</span>
                            <input class="form-control" [ngClass]="{'invalid-form': mostrarError.contacto }"
                                formControlName="contacto" type="text"
                                placeholder="Ingresa Contacto de Facturación de Proveedor" />
                            <p *ngIf="mostrarError.contacto" class="invalid-form-p">Por favor, ingresa un contacto de
                                facturación.</p>
                        </div>
                    </div>
                </fieldset>

                <fieldset *ngIf="step === 3" class="mb-4 fieldset-container">
                    <legend class="custom-legend">Datos Fiscales</legend>
                    <div class="row mb-2">
                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Nombre Titular</span>
                            <input class="form-control" [ngClass]="{'invalid-form': mostrarError.titular }"
                                formControlName="titular" type="text"
                                placeholder="Ingresa Número de Cuenta de Proveedor" />
                            <p *ngIf="mostrarError.titular" class="invalid-form-p">Por favor, ingresa el nombre del
                                titular.</p>
                        </div>
                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Número de Cuenta</span>
                            <input class="form-control" [ngClass]="{'invalid-form': mostrarError.noCuenta }"
                                formControlName="noCuenta" type="text"
                                placeholder="Ingresa Número de Cuenta de Proveedor" />
                            <p *ngIf="mostrarError.noCuenta" class="invalid-form-p">Por favor, ingresa un número de
                                cuenta.</p>
                        </div>

                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Banco</span>
                            <select class="form-select form-select-lg" [ngClass]="{'invalid-form': mostrarError.banco }"
                                formControlName="banco">
                                <option value="">Selecciona una Opción</option>
                                <option *ngFor="let item of bancos" [value]="item.bancosId">{{item.clave}} -
                                    {{item.nombreCorto}}</option>
                            </select>
                            <p *ngIf="mostrarError.banco" class="invalid-form-p">Por favor, selecciona una opción
                                válida.</p>
                        </div>
                    </div>


                    <div class="row">

                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Tipo de Compra</span>
                            <select class="form-select form-select-lg"
                                [ngClass]="{'invalid-form': mostrarError.tipoCompra }" formControlName="tipoCompra">
                                <option value="">Selecciona una Opción</option>
                                <option *ngFor="let item of tipoCompra" [value]="item.tipoCompraId">{{item.clave}} -
                                    {{item.descripcion}}</option>
                            </select>
                            <p *ngIf="mostrarError.tipoCompra" class="invalid-form-p">Por favor, selecciona una opción
                                válida.</p>
                        </div>
                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Regimen Fiscal</span>
                            <select class="form-select form-select-lg"
                                [ngClass]="{'invalid-form': mostrarError.regimenFiscal }"
                                formControlName="regimenFiscal">
                                <option value="">Selecciona una Opción</option>
                                <option *ngFor="let item of regimenFiscal" [value]="item.tipoRegimenId">
                                    {{item.descripcion}}</option>
                            </select>
                            <p *ngIf="mostrarError.regimenFiscal" class="invalid-form-p">Por favor, selecciona una
                                opción válida.</p>
                        </div>
                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Condiciones de Pago</span>
                            <select class="form-select form-select-lg"
                                [ngClass]="{'invalid-form': mostrarError.condicionesPago }"
                                formControlName="condicionesPago">
                                <option value="">Selecciona una Opción</option>
                                <option *ngFor="let item of condicionesPago" [value]="item.condicionPagoId">
                                    {{item.descripcion}}</option>
                            </select>
                            <p *ngIf="mostrarError.condicionesPago" class="invalid-form-p">Por favor, selecciona una
                                opción válida.</p>

                        </div>

                    </div>

                    <div class="row">

                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Formas de Pago</span>
                            <select class="form-select form-select-lg"
                                [ngClass]="{'invalid-form': mostrarError.formasPago }" formControlName="formasPago">
                                <option value="">Selecciona una Opción</option>
                                <option *ngFor="let item of formasPago" [value]="item.formaPagoId">
                                    {{item.nombreFormaPago}}</option>
                            </select>
                            <p *ngIf="mostrarError.formasPago" class="invalid-form-p">Por favor, selecciona una opción
                                válida.</p>
                        </div>

                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Días de crédito</span>
                            <input class="form-control" [ngClass]="{'invalid-form': mostrarError.diasPago }"
                                formControlName="diasPago" type="number">
                            <p *ngIf="mostrarError.diasPago" class="invalid-form-p">Por favor, ingresa dias de crédito.
                            </p>
                        </div>
                    </div>

                </fieldset>

                <fieldset *ngIf="step === 4" class="mb-4 fieldset-container">
                    <legend class="custom-legend">Documentación</legend>
                    <div class="col-12 mb-2">
                        <div id="options" class="mb-3">
                            <div class="d-flex flex-wrap text-nowrap mb-n1" id="filter" data-option-key="filter">
                                <a (click)="show('group1')" [ngClass]="{ 'active': gallery.group1 }"
                                    class="btn btn-white btn-sm border-0 me-1 mb-1">
                                    Comprobante Situacion Fiscal
                                    <i *ngIf="!pdfSrc" class="fa-solid fa-square-xmark ms-2 text-red"></i>
                                </a>
                                <a href="javascript:;" (click)="show('group2')" [ngClass]="{ 'active': gallery.group2 }"
                                    class="btn btn-white btn-sm border-0 me-1 mb-1">
                                    Comprobante Domicilio
                                    <i *ngIf="!pdfSrc2" class="fa-solid fa-square-xmark ms-2 text-red"></i>
                                </a>
                                <a href="javascript:;" (click)="show('group3')" [ngClass]="{ 'active': gallery.group3 }"
                                    class="btn btn-white btn-sm border-0 me-1 mb-1">
                                    Caratula Bancaria
                                    <i *ngIf="!pdfSrc3" class="fa-solid fa-square-xmark ms-2 text-red"></i>
                                </a>
                                <a *ngIf="repseHabilitado()" href="javascript:;" (click)="show('group4')"
                                    [ngClass]="{ 'active': gallery.group4 }"
                                    class="btn btn-white btn-sm border-0 me-1 mb-1">
                                    REPSE
                                    <i *ngIf="!pdfSrc4" class="fa-solid fa-square-xmark ms-2 text-red"></i>
                                </a>
                            </div>
                        </div>
                        <div id="gallery" class="gallery row">
                            <div class="gallery-group-1" *ngIf="gallery.group1 || gallery.all">
                                <div class="file-upload">
                                    <!-- <button class="btn btn-primary">
                                    <label for="csvReader">Subir Archivo</label>
                                </button> -->

                                    <span class="ms-2">{{pdfName}}</span>
                                    <i *ngIf="pdfName" (click)="resetUploadFile(1)"
                                        class="fa-solid fa-square-xmark ms-2"></i>
                                    <input style="display: none;" name="csvReader" type="file" id="csvReader"
                                        (change)="onFileSelected($event, 1)" accept="application/pdf" />
                                </div>

                                <div class="pdf-preview">
                                    <iframe *ngIf="pdfSrc" [src]="pdfSrc" style="width: 100%;" height="400"></iframe>
                                </div>
                            </div>
                            <div class="gallery-group-2" *ngIf="gallery.group2 || gallery.all">
                                <div class="file-upload">
                                    <!-- <button class="btn btn-primary">
                                    <label for="csvReader2">Subir Archivo</label>
                                </button> -->

                                    <span class="ms-2">{{pdfName2}}</span>
                                    <i *ngIf="pdfName2" (click)="resetUploadFile(2)"
                                        class="fa-solid fa-square-xmark ms-2"></i>
                                    <input style="display: none;" name="csvReader2" type="file" id="csvReader2"
                                        (change)="onFileSelected($event, 2)" accept="application/pdf" />
                                </div>

                                <div class="pdf-preview">
                                    <iframe *ngIf="pdfSrc2" [src]="pdfSrc2" style="width: 100%;" height="400"></iframe>
                                </div>
                            </div>
                            <div class="gallery-group-3" *ngIf="gallery.group3 || gallery.all">
                                <div class="file-upload">
                                    <!-- <button class="btn btn-primary">
                                    <label for="csvReader3">Subir Archivo</label>
                                </button> -->

                                    <span class="ms-2">{{pdfName3}}</span>
                                    <i *ngIf="pdfName3" (click)="resetUploadFile(3)"
                                        class="fa-solid fa-square-xmark ms-2"></i>
                                    <input style="display: none;" name="csvReader3" type="file" id="csvReader3"
                                        (change)="onFileSelected($event, 3)" accept="application/pdf" />
                                </div>

                                <div class="pdf-preview">
                                    <iframe *ngIf="pdfSrc3" [src]="pdfSrc3" style="width: 100%;" height="400"></iframe>
                                </div>
                            </div>
                            <div class="gallery-group-4" *ngIf="gallery.group4 || gallery.all">
                                <div class="file-upload">
                                    <!-- <button class="btn btn-primary">
                                    <label for="csvReader3">Subir Archivo</label>
                                </button> -->

                                    <span class="ms-2">{{pdfName3}}</span>
                                    <i *ngIf="pdfName3" (click)="resetUploadFile(3)"
                                        class="fa-solid fa-square-xmark ms-2"></i>
                                    <input style="display: none;" name="csvReader3" type="file" id="csvReader3"
                                        (change)="onFileSelected($event, 3)" accept="application/pdf" />
                                </div>

                                <div class="pdf-preview">
                                    <iframe *ngIf="pdfSrc3" [src]="pdfSrc3" style="width: 100%;" height="400"></iframe>
                                </div>
                            </div>
                        </div>

                    </div>
                </fieldset>

                <div class="d-flex flex-row justify-content-end">
                    <button *ngIf="step > 1" (click)="nextStep(2)" class="btn btn-secondary"><i
                            class="fa-solid fa-angle-left"></i> Anterior</button>
                    <button *ngIf="step < 4" (click)="validateStep(1)" class="btn btn-primary ms-2">Siguiente <i
                            class="fa-solid fa-angle-right"></i> </button>
                    <button *ngIf="step === 4" (click)="guardarProveedor()" class="btn btn-primary ms-2">Confirmar
                        Cambios a Proveedor</button>
                </div>
            </div>
        </form>
    </div>
</div>




<!--NUEVO DISEÑO EN UNA HOJA-->
<div class="header-container-new header-background">
    <span class="fs-20px font-weight-bold text-white">{{headerTitle}} - {{proveedorForm.value.nombre}}</span>
    <span class="text-white fs-16px" style="cursor: pointer;" (click)="closeDialog()">
        <i class="fa fa-times fs-20px"></i>
    </span>
</div>
<div *ngIf="!loadingView" class="dialog-container">
    <form [formGroup]="proveedorForm">
        <mat-accordion multi>

            <mat-expansion-panel expanded class="mb-2">

                <mat-expansion-panel-header class="panel-header">

                    <mat-panel-title class="custom-legend">
                        <i class="fa fa-building me-2"></i>
                        Datos del proveedor
                    </mat-panel-title>

                </mat-expansion-panel-header>

                <fieldset class="mb-4 fieldset-container mt-4">
                    <div class="row">

                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Tipo de Persona</span>
                            <select class="form-select form-select-lg"
                                [ngClass]="{'invalid-form': mostrarError.tipoPersona }" formControlName="tipoPersona">
                                <option value="">Selecciona una Opción</option>
                                <option *ngFor="let item of tipoPersona" [value]="item.tipoPersonaId">
                                    {{item.clavePersona}}
                                    - {{item.descripcionPersona}}</option>
                            </select>
                            <p *ngIf="mostrarError.tipoPersona" class="invalid-form-p">Por favor, selecciona una opción
                                válida.</p>
                        </div>
                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">ID CIF</span>
                            <input class="form-control" [ngClass]="{'invalid-form': mostrarError.idRfc }"
                                formControlName="idRfc" (input)="validarNumeros('idRfc')" type="text" maxlength="11"
                                placeholder="Ingresa el ID CIF" (blur)="habilitarRFC()" />
                            <p *ngIf="mostrarError.idCif" class="invalid-form-p">{{erroridCIFMessage}}</p>
                            <!-- <p *ngIf="mostrarError.idRfc" class="invalid-form-p">Por favor, ingresa una ID CIF</p> -->
                        </div>
                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">RFC</span>
                            <input class="form-control" [ngClass]="{'invalid-form': mostrarError.rfc }"
                                formControlName="rfc" type="text" placeholder="Ingresa RFC de Proveedor" />
                            <p *ngIf="mostrarError.rfc" class="invalid-form-p">Por favor, ingresa el RFC</p>
                        </div>

                        <!-- <div class="col-6">
                        <span class="fs-14px font-weight-bold">Estatus</span>
                        <select class="form-select form-select-lg" formControlName="estatus">
                            <option value="">Selecciona una Opción</option>
                            <option *ngFor="let item of estatus" [value]="item.estatusProveedorId">{{item.descripcion}}</option>
                        </select>
                        <p *ngIf="mostrarError.moneda" class="invalid-form-p">Por favor, selecciona una opción válida</p>
                    </div> -->
                    </div>
                    <div class="row mb-2">

                        <div class="col-6">
                            <span class="fs-14px font-weight-bold d-block mt-1">Nombre Proveedor</span>
                            <input class="form-control" [ngClass]="{'invalid-form': mostrarError.nombre }"
                                formControlName="nombre" type="text" placeholder="Ingresa Nombre de Proveedor" />
                            <p *ngIf="mostrarError.nombre" class="invalid-form-p">Por favor, ingresa un nombre.</p>
                        </div>

                        <div class="col-6">
                            <span class="fs-14px font-weight-bold d-block mt-1">Razón Social</span>
                            <input class="form-control" [ngClass]="{'invalid-form': mostrarError.razonSocial }"
                                formControlName="razonSocial" type="text"
                                placeholder="Ingresa Razón Social de Proveedor" />
                            <p *ngIf="mostrarError.razonSocial" class="invalid-form-p">Por favor, ingresa una razón
                                social
                            </p>
                        </div>
                        <div class="col-12">
                            <span class="fs-14px font-weight-bold d-block mt-1">Moneda</span>

                        <input
                            [disabled]="true"
                            class="form-control"
                            [value]="monedasTexto"
                            type="text"
                            readonly
                            placeholder="Monedas" />

                            <!--<mat-select [disabled]="false" class="form-control moneda-select-disabled"
                                style="font-size: 14px;" placeholder="Selecciona uno o más tipos de moneda" multiple
                                [(value)]="monedaSelect">
                                <mat-option *ngFor="let option of tipoMoneda" [value]="option.tipoMonedaId"
                                    [disabled]="true">{{option.clave}} - {{option.descripcion}}</mat-option>
                            </mat-select>
                            <p *ngIf="mostrarError.moneda" class="invalid-form-p">Por favor, selecciona una opción
                                válida
                            </p>-->
                        </div>
                        <div class="col-12">
                            <span class="fs-14px font-weight-bold d-block mt-1">Empresa(s)</span>

                             <input
                             [disabled]="true"
                            class="form-control"
                            [value]="empresasTexto"
                            type="text"
                            readonly
                            placeholder="Empresas" />

                            <!--<mat-select [disabled]="false" class="form-control empresa-select-disabled"
                                style="font-size: 14px;" placeholder="Selecciona uno o más empresas" multiple
                                [(value)]="empresaSelect" (selectionChange)="validarSeleccion()">
                                <mat-option *ngFor="let option of empresas" [value]="option.empresaId"
                                    [disabled]="true">{{option.nombreEmpresa}}</mat-option>
                            </mat-select>
                            <p *ngIf="mostrarError.empresa" class="invalid-form-p">Por favor, selecciona una opción
                                válida
                            </p>-->
                        </div>

                    </div>
                </fieldset>

            </mat-expansion-panel>

            <mat-expansion-panel expanded class="mb-2">

                <mat-expansion-panel-header class="panel-header">

                    <mat-panel-title class="custom-legend">
                        <i class="fa fa-address-book me-2"></i>
                        Datos de Contacto
                    </mat-panel-title>

                </mat-expansion-panel-header>

                <fieldset class="fieldset-container mt-4">

                    <fieldset class="mb-4">
                        <div class="row mb-2">

                            <div class="col-6">
                                <span class="fs-14px font-weight-bold">Correo Electrónico</span>
                                <input class="form-control" [ngClass]="{'invalid-form': mostrarError.correo }"
                                    formControlName="correo"
                                    [ngClass]="{'invalid-form': !validEmail,  'valid-form': validEmail }"
                                    (ngModelChange)="validarEmail($event)" type="text"
                                    placeholder="Ingresa Correo Electrónico de Proveedor" />
                                <p *ngIf="mostrarError.correo || errorValidarCorreo" class="invalid-form-p">Por favor,
                                    ingresa
                                    un correo válido.</p>
                            </div>

                            <div class="col-6">
                                <span class="fs-14px font-weight-bold">Dirección</span>
                                <input class="form-control" [ngClass]="{'invalid-form': mostrarError.direccion }"
                                    formControlName="direccion" type="text"
                                    placeholder="Ingresa Dirección de Proveedor" />
                                <p *ngIf="mostrarError.direccion" class="invalid-form-p">Por favor, ingresa una
                                    direción.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <span class="fs-14px font-weight-bold">Teléfono</span>
                                <input class="form-control" [ngClass]="{'invalid-form': mostrarError.telefono }"
                                    formControlName="telefono" type="text"
                                    placeholder="Ingresa Teléfono de Proveedor" />
                                <p *ngIf="mostrarError.telefono" class="invalid-form-p">Por favor, ingresa un teléfono.
                                </p>
                            </div>
                            <div class="col-6">
                                <span class="fs-14px font-weight-bold">Contacto de Facturación</span>
                                <input class="form-control" [ngClass]="{'invalid-form': mostrarError.contacto }"
                                    formControlName="contacto" type="text"
                                    placeholder="Ingresa Contacto de Facturación de Proveedor" />
                                <p *ngIf="mostrarError.contacto" class="invalid-form-p">Por favor, ingresa un contacto
                                    de
                                    facturación.</p>
                            </div>
                        </div>
                    </fieldset>

                </fieldset>

            </mat-expansion-panel>

            <mat-expansion-panel expanded class="mb-2">

                <mat-expansion-panel-header class="panel-header">

                    <mat-panel-title class="custom-legend">
                        <i class="fa fa-university me-2"></i>
                        Datos Fiscales
                    </mat-panel-title>

                </mat-expansion-panel-header>


                <fieldset class="mb-4 fieldset-container mt-4">
                    <div class="row mb-2">
                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Nombre Titular</span>
                            <input class="form-control" [ngClass]="{'invalid-form': mostrarError.titular }"
                                formControlName="titular" type="text"
                                placeholder="Ingresa Número de Cuenta de Proveedor" />
                            <p *ngIf="mostrarError.titular" class="invalid-form-p">Por favor, ingresa el nombre del
                                titular.
                            </p>
                        </div>
                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Número de Cuenta</span>
                            <input class="form-control" [ngClass]="{'invalid-form': mostrarError.noCuenta }"
                                formControlName="noCuenta" type="text"
                                placeholder="Ingresa Número de Cuenta de Proveedor" />
                            <p *ngIf="mostrarError.noCuenta" class="invalid-form-p">Por favor, ingresa un número de
                                cuenta.
                            </p>
                        </div>

                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Banco</span>
                            <select class="form-select form-select-lg" [ngClass]="{'invalid-form': mostrarError.banco }"
                                formControlName="banco">
                                <option value="">Selecciona una Opción</option>
                                <option *ngFor="let item of bancos" [value]="item.bancosId">{{item.clave}} -
                                    {{item.nombreCorto}}</option>
                            </select>
                            <p *ngIf="mostrarError.banco" class="invalid-form-p">Por favor, selecciona una opción
                                válida.
                            </p>
                        </div>
                    </div>


                    <div class="row">

                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Tipo de Compra</span>
                            <select class="form-select form-select-lg"
                                [ngClass]="{'invalid-form': mostrarError.tipoCompra }" formControlName="tipoCompra">
                                <option value="">Selecciona una Opción</option>
                                <option *ngFor="let item of tipoCompra" [value]="item.tipoCompraId">{{item.clave}} -
                                    {{item.descripcion}}</option>
                            </select>
                            <p *ngIf="mostrarError.tipoCompra" class="invalid-form-p">Por favor, selecciona una opción
                                válida.</p>
                        </div>
                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Regimen Fiscal</span>
                            <select class="form-select form-select-lg"
                                [ngClass]="{'invalid-form': mostrarError.regimenFiscal }"
                                formControlName="regimenFiscal">
                                <option value="">Selecciona una Opción</option>
                                <option *ngFor="let item of regimenFiscal" [value]="item.tipoRegimenId">
                                    {{item.descripcion}}
                                </option>
                            </select>
                            <p *ngIf="mostrarError.regimenFiscal" class="invalid-form-p">Por favor, selecciona una
                                opción
                                válida.</p>
                        </div>
                        <div class="col-4">
                            <span class="fs-14px font-weight-bold">Condiciones de Pago</span>
                            <select class="form-select form-select-lg"
                                [ngClass]="{'invalid-form': mostrarError.condicionesPago }"
                                formControlName="condicionesPago">
                                <option value="">Selecciona una Opción</option>
                                <option *ngFor="let item of condicionesPago" [value]="item.condicionPagoId">
                                    {{item.descripcion}}</option>
                            </select>
                            <p *ngIf="mostrarError.condicionesPago" class="invalid-form-p">Por favor, selecciona una
                                opción
                                válida.</p>

                        </div>

                    </div>

                    <div class="row">

                        <div class="col-4">
                            <span class="fs-14px font-weight-bold d-block mt-1">Formas de Pago</span>
                            <select class="form-select form-select-lg"
                                [ngClass]="{'invalid-form': mostrarError.formasPago }" formControlName="formasPago">
                                <option value="">Selecciona una Opción</option>
                                <option *ngFor="let item of formasPago" [value]="item.formaPagoId">
                                    {{item.nombreFormaPago}}
                                </option>
                            </select>
                            <p *ngIf="mostrarError.formasPago" class="invalid-form-p">Por favor, selecciona una opción
                                válida.</p>
                        </div>

                        <div class="col-4">
                            <span class="fs-14px font-weight-bold d-block mt-1">Días de crédito</span>
                            <input class="form-control" [ngClass]="{'invalid-form': mostrarError.diasPago }"
                                formControlName="diasPago" type="number">
                            <p *ngIf="mostrarError.diasPago" class="invalid-form-p">Por favor, ingresa dias de crédito.
                            </p>
                        </div>
                    </div>

                </fieldset>

            </mat-expansion-panel>


            <mat-expansion-panel expanded>

                <mat-expansion-panel-header class="panel-header">

                    <mat-panel-title class="custom-legend">
                        <i class="fa fa-folder-open me-2"></i>
                        Documentación
                    </mat-panel-title>

                </mat-expansion-panel-header>
                <fieldset class="mb-4 fieldset-container mt-4">
                    <div class="col-12 mb-2">
                        <div id="options" class="mb-3">
                            <div class="d-flex flex-wrap text-nowrap mb-n1" id="filter" data-option-key="filter">
                                <a (click)="show('group1')" [ngClass]="{ 'active': gallery.group1 }"
                                    class="btn btn-white btn-sm border-0 me-1 mb-1">
                                    Comprobante Situacion Fiscal
                                    <i *ngIf="!pdfSrc" class="fa-solid fa-square-xmark ms-2 text-red"></i>
                                </a>
                                <a href="javascript:;" (click)="show('group2')" [ngClass]="{ 'active': gallery.group2 }"
                                    class="btn btn-white btn-sm border-0 me-1 mb-1">
                                    Comprobante Domicilio
                                    <i *ngIf="!pdfSrc2" class="fa-solid fa-square-xmark ms-2 text-red"></i>
                                </a>
                                <a href="javascript:;" (click)="show('group3')" [ngClass]="{ 'active': gallery.group3 }"
                                    class="btn btn-white btn-sm border-0 me-1 mb-1">
                                    Caratula Bancaria
                                    <i *ngIf="!pdfSrc3" class="fa-solid fa-square-xmark ms-2 text-red"></i>
                                </a>
                                <a *ngIf="repseHabilitado()" href="javascript:;" (click)="show('group4')"
                                    [ngClass]="{ 'active': gallery.group4 }"
                                    class="btn btn-white btn-sm border-0 me-1 mb-1">
                                    REPSE
                                    <i *ngIf="!pdfSrc4" class="fa-solid fa-square-xmark ms-2 text-red"></i>
                                </a>
                            </div>
                        </div>
                        <div id="gallery" class="gallery row">
                            <div class="gallery-group-1" *ngIf="gallery.group1 || gallery.all">
                                <div class="file-upload">
                                    <!-- <button class="btn btn-primary">
                                    <label for="csvReader">Subir Archivo</label>
                                </button> -->

                                    <span class="ms-2">{{pdfName}}</span>
                                    <i *ngIf="pdfName" (click)="resetUploadFile(1)"
                                        class="fa-solid fa-square-xmark ms-2"></i>
                                    <input style="display: none;" name="csvReader" type="file" id="csvReader"
                                        (change)="onFileSelected($event, 1)" accept="application/pdf" />
                                </div>

                                <div class="pdf-preview">
                                    <iframe *ngIf="pdfSrc" [src]="pdfSrc" style="width: 100%;" height="400"></iframe>
                                </div>
                            </div>
                            <div class="gallery-group-2" *ngIf="gallery.group2 || gallery.all">
                                <div class="file-upload">
                                    <!-- <button class="btn btn-primary">
                                    <label for="csvReader2">Subir Archivo</label>
                                </button> -->

                                    <span class="ms-2">{{pdfName2}}</span>
                                    <i *ngIf="pdfName2" (click)="resetUploadFile(2)"
                                        class="fa-solid fa-square-xmark ms-2"></i>
                                    <input style="display: none;" name="csvReader2" type="file" id="csvReader2"
                                        (change)="onFileSelected($event, 2)" accept="application/pdf" />
                                </div>

                                <div class="pdf-preview">
                                    <iframe *ngIf="pdfSrc2" [src]="pdfSrc2" style="width: 100%;" height="400"></iframe>
                                </div>
                            </div>
                            <div class="gallery-group-3" *ngIf="gallery.group3 || gallery.all">
                                <div class="file-upload">
                                    <!-- <button class="btn btn-primary">
                                    <label for="csvReader3">Subir Archivo</label>
                                </button> -->

                                    <span class="ms-2">{{pdfName3}}</span>
                                    <i *ngIf="pdfName3" (click)="resetUploadFile(3)"
                                        class="fa-solid fa-square-xmark ms-2"></i>
                                    <input style="display: none;" name="csvReader3" type="file" id="csvReader3"
                                        (change)="onFileSelected($event, 3)" accept="application/pdf" />
                                </div>

                                <div class="pdf-preview">
                                    <iframe *ngIf="pdfSrc3" [src]="pdfSrc3" style="width: 100%;" height="400"></iframe>
                                </div>
                            </div>
                            <div class="gallery-group-4" *ngIf="gallery.group4 || gallery.all">
                                <div class="file-upload">
                                    <!-- <button class="btn btn-primary">
                                    <label for="csvReader3">Subir Archivo</label>
                                </button> -->

                                    <span class="ms-2">{{pdfName3}}</span>
                                    <i *ngIf="pdfName3" (click)="resetUploadFile(3)"
                                        class="fa-solid fa-square-xmark ms-2"></i>
                                    <input style="display: none;" name="csvReader3" type="file" id="csvReader3"
                                        (change)="onFileSelected($event, 3)" accept="application/pdf" />
                                </div>

                                <div class="pdf-preview">
                                    <iframe *ngIf="pdfSrc3" [src]="pdfSrc3" style="width: 100%;" height="400"></iframe>
                                </div>
                            </div>
                        </div>

                    </div>
                </fieldset>


            </mat-expansion-panel>


        </mat-accordion>
    </form>
</div>
<div *ngIf="loadingView">
    <div class="d-flex flex-column align-items-center my-5">
        <div class="spinner-border mb-3 spinner-custom" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>

        <div class="text-muted">
            Cargando...
        </div>
    </div>
</div>
<div *ngIf="!loadingView" class="d-flex justify-content-end mt-2 mb-2 me-3">
    <button (click)="guardarProveedor()" class="btn btn-primary ms-2">Confirmar Cambios a Proveedor</button>
</div>